"use client";

import { usePathname } from "next/navigation";
import { motion } from "framer-motion";

export function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isCustomerPortal = pathname?.startsWith("/customer");

  if (isCustomerPortal) {
    return <div className="w-full min-w-0 min-h-full">{children}</div>;
  }

  return (
    <motion.div
      key={pathname}
      initial={false}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      className="w-full min-w-0 min-h-full"
    >
      {children}
    </motion.div>
  );
}
